import axios from 'Axios';
import {
  CRITERIA_ENDPOINT,
  VALUE_PATTERNS,
  singleCriteria,
} from '../api/Routes';

function getAllCriteriaStart() {
  return {
    type: 'GET_ALL_CRITERIA_START',
  };
}

function getAllCriteriaDone(data) {
  return {
    type: 'GET_ALL_CRITERIA_DONE',
    criteria: data,
  };
}
function addCriteriaStart() {
  return {
    type: 'ADD_CRITERIA_START',
  };
}

function addCriteriaDone(data) {
  return {
    type: 'ADD_CRITERIA_DONE',
    addedCriteria: data,
  };
}
function getValuePatternsStart() {
  return {
    type: 'GET_VALUE_PATTERNS_START',
  };
}

function getValuePatternsDone(data) {
  return {
    type: 'GET_VALUE_PATTERNS_DONE',
    valuePatterns: data,
  };
}
function deleteCriteriaStart() {
  return {
    type: 'DELETE_CRITERIA_START',
  };
}

function deleteCriteriaDone(data) {
  return {
    type: 'DELETE_CRITERIA_DONE',
    deletedCriteria: data,
  };
}

function editCriteriaStart() {
  return {
    type: 'EDIT_CRITERIA_START',
  };
}

function editCriteriaDone(data) {
  return {
    type: 'EDIT_CRITERIA_DONE',
    editedCriteria: data,
  };
}
function criteriaError(errorMessage) {
  return {
    type: 'CRITERIA_ERROR',
    errorMessage,
  };
}
export const getAllCriteria = () => {
  return function(dispatch) {
    dispatch(getAllCriteriaStart());

    axios
      .get(CRITERIA_ENDPOINT)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getAllCriteriaDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(criteriaError(errorMessage));
      });
  };
};
export const addCriteria = criteriaObject => {
  return function(dispatch) {
    dispatch(addCriteriaStart());

    axios
      .post(CRITERIA_ENDPOINT, criteriaObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(addCriteriaDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(criteriaError(errorMessage));
      });
  };
};
export const getValuePatterns = () => {
  return function(dispatch) {
    dispatch(getValuePatternsStart());

    axios
      .get(VALUE_PATTERNS)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getValuePatternsDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(criteriaError(errorMessage));
      });
  };
};
export const deleteCriteria = criteriaId => {
  return function(dispatch) {
    dispatch(deleteCriteriaStart());

    axios
      .delete(singleCriteria(criteriaId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(() => {
        dispatch(deleteCriteriaDone(criteriaId));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(criteriaError(errorMessage));
      });
  };
};
export const editCriteria = (criteriaId, criteriaObject) => {
  return function(dispatch) {
    dispatch(editCriteriaStart());

    axios
      .put(singleCriteria(criteriaId), criteriaObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(editCriteriaDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(criteriaError(errorMessage));
      });
  };
};
